import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgArrowDown = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      d="m12 19-6-6m6 6 6-6m-6 6V5"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </Svg>
);
const Memo = memo(SvgArrowDown);
export default Memo;
